import { useReferenceSafeObject, useMutationObserver } from '@flex-design-system/fx-utils/hooks';
import { useCallback, useEffect } from 'react';

function useNearestSeparatorHidden(groupElement, optionParams) {
  const options = useReferenceSafeObject(optionParams);
  const refreshHiddenState = useCallback((element) => {
    const prevSibling = element.previousSibling;
    const nextSibling = element.nextSibling;
    const isHiddenGroup = element.getAttribute("hidden") !== null;
    whenSeparatorRole(
      prevSibling,
      isHiddenGroup ? setHiddenTrue : setHiddenFalse
    );
    whenSeparatorRole(
      nextSibling,
      isHiddenGroup ? setHiddenTrue : setHiddenFalse
    );
  }, []);
  useEffect(() => {
    if (groupElement !== null) {
      refreshHiddenState(groupElement);
    }
  }, [groupElement, refreshHiddenState]);
  useMutationObserver(groupElement, {
    options: {
      ...options,
      attributes: true,
      attributeFilter: ["hidden"]
    },
    callback: () => {
      if (groupElement === null) {
        return;
      }
      refreshHiddenState(groupElement);
    }
  });
}
function whenSeparatorRole(element, callback) {
  if (element === null || element.getAttribute("role") !== "separator") {
    return;
  }
  return callback(element);
}
function setHiddenValue(element, hidden) {
  hidden ? element.setAttribute("hidden", "true") : element.removeAttribute("hidden");
}
function setHiddenTrue(element) {
  setHiddenValue(element, true);
}
function setHiddenFalse(element) {
  setHiddenValue(element, false);
}

export { useNearestSeparatorHidden as default };
//# sourceMappingURL=useNearestSeparatorHidden.mjs.map
